import { Locale } from '@app/origami-api/constants';
import { getServerConfig } from '@app/origami-api/server-config';
import { DomManipulate } from '@app/shared/utils/dom-manipulate';
import { BuildProps } from '@app/origami-api/build-props';

const TI_LOC = 'ti-loc';

export class LocaleSwitcher {
  private static currentLocale: Locale;

  static init(explicitLocale?: Locale): Promise<Locale> {
    this.currentLocale =
      explicitLocale || (localStorage.getItem(TI_LOC) as Locale) || getServerConfig().defaultLocale || Locale.en_US;
    this.currentLocale = this.currentLocale.replace(/"/g, '') as Locale; // compatibility with classic UI

    if (!Object.keys(Locale).includes(this.currentLocale)) {
      this.currentLocale = Locale.en_US;
    }
    return this.loadLocale(this.currentLocale);
  }

  static getCurrentLocale(): Locale {
    return this.currentLocale;
  }

  static setLocale(newLocale: Locale, forceOnlyInfNew?: boolean): void {
    if (!forceOnlyInfNew || (newLocale && newLocale !== this.currentLocale)) {
      this.currentLocale = newLocale;
      localStorage.setItem(TI_LOC, newLocale || '');
      location.reload();
    }
  }

  private static loadLocale(locale: Locale): Promise<Locale> {
    const localeUrl = `assets/ti-strings/${locale}.js`;
    const scriptSrc = `${localeUrl}?nocache=${BuildProps.OrigamiBuildNumber}`;

    return new Promise((resolve, reject) => {
      DomManipulate.addScriptToDocumentHead(
        scriptSrc,
        () => resolve(locale),
        () => reject(`UI developers: '${localeUrl}' not found! You need to run grunt task!`),
      );
    });
  }
}
